<ui-card class="w-full h-full bg-white rounded-lg">
	<h3 card-header class="text-xl font-medium">Package Details</h3>

	<div card-content class="flex flex-col gap-4 h-full">
		<div class="flex flex-col gap-1">
			<h6 class="font-medium">Sent On</h6>
			<p class="p-sm">
				{{ envelope().sentOn | date: 'MMM d, YYYY' }}
			</p>
		</div>
		<div class="flex flex-col gap-1">
			<h6 class="font-medium">Sent By</h6>
			<div class="flex gap-2 items-center">
				<ui-avatar [initials]="envelope().sentByName | initials" />
				<p class="p-sm">{{ envelope().sentByName }}</p>
			</div>
		</div>

		<div class="flex flex-col gap-1">
			<h6 class="font-medium">Package</h6>
			<button
				class="inline-flex gap-1 items-center p-sm text-tealGreen-500 hover:text-tealGreen-700 underline duration-300"
				(click)="onClickViewEnvelope()"
			>
				View {{ mappedEnvelopeStatusText() }} Package
				<i-tabler name="eye-share" class="h-4 w-4" />
			</button>
		</div>

		<div class="flex flex-col gap-1">
			<h6 class="font-medium">Note</h6>
			<p class="p-sm">
				{{ envelope().note }}
			</p>
		</div>
		<div class="flex flex-col gap-1">
			<h6 class="font-medium">Documents</h6>
			<ul
				class="list-inside list-disc w-full text-sm/6 font-normal text-gray-700 *:truncate"
			>
				@for (documentName of documentNames(); track documentName) {
					<li>{{ documentName }}</li>
				}
			</ul>
		</div>
	</div>
</ui-card>
